var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageConfig)?_c('div',_vm._l((_vm.pageConfig.components),function(item){return _c('div',{key:item.id},[_c(item.component,{tag:"component",attrs:{"props":item.props}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }